import { BrandMark } from "../commons/Brand";
import { Badge } from "../commons/UI";

export const SobreNosotros = () => (
  <>
    <div className="mt-12 grid md:grid-cols-2 gap-10 items-start">
      <div>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-100">Sobre nosotros</h1>
        <p className="text-slate-300 mt-4 leading-relaxed">
          En Velasco Software combinamos producto y tecnología para crear impacto real. Nuestro enfoque es
          pragmático: agregar valor rápido, medir e iterar. Construimos AI Agents, MCPs y automatizaciones
          n8n sobre stacks modernos (React, Next.js, Node, Java Spring Boot).
        </p>
        <ul className="mt-6 space-y-2 text-slate-300 list-disc list-inside">
          <li>+2 años construyendo productos para distintos rubros.</li>
          <li>Experiencia en ecommerce, fintech, mobile y SaaS.</li>
          <li>Compromiso con accesibilidad, performance y seguridad.</li>
        </ul>
      </div>
      <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-gradient-to-br from-indigo-700/30 via-fuchsia-600/10 to-transparent">
        <div className="p-8">
          <h3 className="text-xl font-semibold text-slate-100 flex items-center gap-2"><BrandMark className="h-6" />Nuestra promesa</h3>
          <p className="text-slate-300 mt-3">Transparencia, foco en negocio y entregas constantes. Queremos ser tu equipo extendido, no un proveedor más.</p>
          <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
            <Badge>AI Agents</Badge>
            <Badge>MCP Servers</Badge>
            <Badge>ChatBots</Badge>
            <Badge>n8n</Badge>
          </div>
        </div>
      </div>
    </div>
  </>
);
